import { useForm, SubmitHandler } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { SignUpRequest } from "./api/requestTypes";

export type Inputs = SignUpRequest;

const schema = z
  .object({
    firstName: z.string().min(1, { message: "Enter your first name" }),
    lastName: z.string().min(1, { message: "Enter your last name" }),
    email: z
      .string()
      .min(1, { message: "Enter a valid email address" })
      .email({ message: "Enter a valid email address" }),
    password: z
      .string()
      .regex(
        new RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@.#$!%*?&])[A-Za-zd@.#$!%*?&]{8,15}$/"
        ),
        "Enter a valid password with at least one symbol"
      ),
    confirmPassword: z.string(),
    confirmOlderThan18: z
      .boolean({
        required_error:
          "You must confirm that you are 18 years of age or older and that you accept the Desti.One - Terms of use"
      })
      .refine(val => val === true, {
        message:
          "You must confirm that you are 18 years of age or older and that you accept the Desti.One - Terms of use"
      })
  })
  .refine(data => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"] // path of error
  });

const defaultValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  confirmOlderThan18: false
};

const useSignUp = () => {
  const { handleSubmit, control } = useForm<Inputs>({
    defaultValues,
    resolver: zodResolver(schema)
  });

  const onSubmit: SubmitHandler<Inputs> = data => console.log(data);

  return {
    handleSubmit: handleSubmit(onSubmit),
    control
  };
};

export default useSignUp;
